import { render } from "./management.cattle.io.globalrole.vue?vue&type=template&id=75d6b258&scoped=true"
import script from "./management.cattle.io.globalrole.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.globalrole.vue?vue&type=script&lang=js"

import "./management.cattle.io.globalrole.vue?vue&type=style&index=0&id=75d6b258&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d6b258"]])

export default __exports__